import React, { useState } from "react";
import Gallery from 'react-grid-gallery';

const GalleryLightbox = (props) => {
  return (
    <div>
      {props.isOpen && (
        <Gallery
          images={props.images}
          isOpen={true}
          maxRows={1}
          rowHeight={1}
          enableLightbox={true}
          enableImageSelection={false}
          lightboxWillClose={props.close}
          showLightboxThumbnails={true}
        />
      )}
    </div>
  );
}
export default GalleryLightbox;



// WEBPACK FOOTER //
// ./src/components/foldersComponent/gallery.js